<script>
import moment from 'moment'
const Wrapper = {
    render(createElement) {
        return createElement(this.tag, this.$slots.default);
    },

    props: {
        tag: String
    },
}

export default {
    components: {
        Wrapper
    },

    props: {
        requisition: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
    },

    computed: {
        link() {
            if(this.requisition.closing_date < moment().format('YYYY-MM-DD hh:mm:ss')) {
                return `/recruiter/requisitions/edit/${this.requisition.id}`
            }

            if (this.requisition.current_status == 'created' && this.user.id == this.requisition.creator_id) {
                if (this.requisition.first_approval || this.requisition.second_approval || this.requisition.third_approval) {
                    return `/recruiter/requisitions/approve/${this.requisition.id}`
                }
                return `/recruiter/requisitions/edit/${this.requisition.id}`
            }
            if (['first_approval', 'second_approval', 'third_approval', 'to_publish'].includes(this.requisition.current_status)) {
                return `/recruiter/requisitions/approve/${this.requisition.id}`
            }
            if (this.requisition.current_status == 'ad_creation') {
                return `/recruiter/requisitions/create-ad/${this.requisition.id}`
            }
            if (this.requisition.current_status == 'ad_approval') {
                return `/recruiter/requisitions/approve-ad/${this.requisition.id}`
            }
            if (this.requisition.current_status == 'published') {
                return `/recruiter/requisitions/approve-ad/${this.requisition.id}`
            }

            return null;
        }
    }
}
</script>

<template>
    <wrapper
        :tag="link ? 'a' : 'div'"
        :class="link ? 'link' : ''"
        :href="link"
        class="requisition"
    >
        <div class="font-bold mb-1">
            {{ requisition.person_specification.business_line.company.title }}
        </div>

        <div>
            <span v-if="requisition.is_pipeline"><strong>[Pipeline]</strong></span> - {{ requisition.person_specification.title }}
        </div>

        <div>
            #{{ requisition.id }}
        </div>
        <div v-if="requisition.job_profile">
            Job Profile ID: #{{ requisition.job_profile.id }}
            <div v-if="requisition.job_profile.external_requisition_number">
                External Requisition Number: {{ requisition.job_profile.external_requisition_number }}
            </div>
            <div v-if="requisition.job_profile.sage_job_requisition">
                Sage Job Requisitions: #{{ requisition.job_profile.sage_job_requisition.recruitment_id }} - {{ requisition.job_profile.sage_job_requisition.reference_number }}
            </div>
            <br/>
        </div>
        <div>
            Recruiter: {{ requisition.creator.full_name }}
        </div>

        <div v-if="requisition.current_status == 'first_approval'">
            Approver: {{ requisition.first_approver.full_name }}
        </div>
        <div v-if="requisition.current_status == 'second_approval'">
            Approver: {{ requisition.second_approver.full_name }}
        </div>
        <div v-if="requisition.current_status == 'third_approval'">
            Approver: {{ requisition.third_approver.full_name }}
        </div>
    </wrapper>
</template>

<style lang="scss">
@import './assets/scss/frontend/base/colour_vars.scss';

.requisition {
    display: block;
    padding: 0.5rem;
    text-align: center;
    font-size: 12px;
    border-radius: 4px;
    background-color: #f2f2f2;
    cursor: not-allowed;

    &.link {
        background-color: $off-white;
        cursor: pointer;
        color: #455666;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>